import { useState, FormEvent } from 'react';
import { useIdentity } from '../hooks/useIdentity';

export function UnlockScreen(): JSX.Element {
  const { identity, unlock } = useIdentity();
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isUnlocking, setIsUnlocking] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();
    setError(null);
    setIsUnlocking(true);
    try {
      await unlock(password);
      setPassword('');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erreur de déverrouillage');
    } finally {
      setIsUnlocking(false);
    }
  };

  if (identity === null) {
    return (
      <main>
        <p>Aucune identité.</p>
      </main>
    );
  }

  return (
    <main>
      <h1>Déverrouiller l&apos;identité</h1>
      <p>
        Clé publique : <code>{identity.publicKey.slice(0, 20)}...</code>
      </p>
      <form onSubmit={handleSubmit} aria-label="Déverrouillage par mot de passe">
        <div>
          <label htmlFor="unlock-password">
            Mot de passe
            <input
              id="unlock-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </label>
        </div>
        {error !== null && (
          <p role="alert" style={{ color: 'var(--color-error)' }}>
            {error}
          </p>
        )}
        <button type="submit" disabled={isUnlocking}>
          {isUnlocking ? 'Déverrouillage…' : 'Déverrouiller'}
        </button>
      </form>
    </main>
  );
}
